import {SERVER_URI, TEST_URI, SERVER_URI1} from '../Constants/server'
import { apiGet,apiPost } from '../Utils/axios';

const SIGNUP_URL = `${SERVER_URI}/Login`;
const VERIFY_LOCATION = `${SERVER_URI}/verifyLocation`;

export default {
  signUp: async function (payload) {
    return apiPost(SIGNUP_URL, payload);
  },
    VerifyLocation: async function (payload) {
    return apiPost(VERIFY_LOCATION, payload);
  },
  };